module.exports = __webpack_public_path__ + "img/T7A6686.d3c54eeb.jpg";